























import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product } from '@/store/modules/lib';

@Component
export default class ShBadgeGroup extends Vue {

  // @Prop({ type: String, default: "" }) protected title!: string;
  // @Prop({ type: Array, default: [] }) protected products!: Product[];

  // protected productSelected(productId: string) {
  //   this.$emit('productSelected', productId);
  // }

  // protected productRemove(productId: string) {
  //   this.$emit('productRemove', productId);
  // }

  // protected productEdit(productId: string) {
  //   this.$emit('productEdit', productId);
  // }

  // protected get sortedProducts() {

  //   return this.products.sort(function(a: Product, b: Product) {
  //     return a.title > b.title
  //       ? 1
  //       : (a.title < b.title)
  //         ? -1
  //         : 0;
  //   });

  // }

}

